import React, { useRef, useState } from 'react'

import { MainTemplate, Img, TitleHome, SearchAssets, SelectedAssets } from 'components'
import {
  AnalysisButton,
  BackgroundImages,
  BottomContainer,
  Content,
  Image1,
  Image2,
  Image3,
  LogoWrapper,
} from './styles';
import { useMyContext, useAssets } from 'hooks';

const Logo = ({ src }) => {
  return (
    <LogoWrapper>
      <Img src={src} />
    </LogoWrapper>
  )
};

const HomePage = () => {
  const { t, theme } = useMyContext();
  const serachStringRef = useRef();
  const [ selectedAssets, setSelectedAssets ] = useState([]);
  const { addColor } = useAssets();
  const { innerWidth } = window;

  const hasAsset = (assetId, assetType) => {
    return selectedAssets.findIndex(asset => asset.identifier === assetId && asset.assetType === assetType) !== -1;
  }

  const handleAddAsset = (asset) => {
    if(!hasAsset(asset.identifier, asset.assetType)){
      asset = addColor(asset);
      setSelectedAssets([...selectedAssets, asset]);
    }
  }

  const handleRemoveAsset = (assetId, assetType) => {
    const assetToRemoveIndex = selectedAssets.findIndex(asset => asset.identifier === assetId && asset.assetType === assetType);
    const newArray = [...selectedAssets];
    newArray.splice(assetToRemoveIndex, 1);
    setSelectedAssets([...newArray]);
  }

  const handleClearAssets = () => {
    setSelectedAssets([]);
  }

  return (
    <MainTemplate
      header={<Logo src={theme.logo.img} />}
      id="homepage"
    >
      <Content>
        <TitleHome />
        <SearchAssets searchStringRef={serachStringRef} style={innerWidth > 920 ? {marginTop: '32px'} : {width: '100%'}} addAsset={handleAddAsset} />
        <SelectedAssets assets={selectedAssets} removeAsset={handleRemoveAsset} clearAssets={handleClearAssets} />
        { selectedAssets.length > 0 && 
          <BottomContainer>
            <AnalysisButton
              to={{
                pathname:'/graphic',
                state:{ selectedAssets }
              }}
            >
              {innerWidth > 920 ? t['pages:HomePage:AnalysisButton'] : t['pages:HomePage:AnalysisButton:mobile']}
            </AnalysisButton>
          </BottomContainer>
        }
      </Content>
      {innerWidth > 920 && theme.backgroundImages.length > 0 &&
        <BackgroundImages>
          <Image1 src={theme.backgroundImages[0]} />
          <Image2 src={theme.backgroundImages[1]} />
          <Image3 src={theme.backgroundImages[2]} />
        </BackgroundImages>
      }
    </MainTemplate>
  )
}

export default HomePage
